import React from 'react';
import { Helmet } from 'react-helmet';
import TopBanner from './TopBanner';
import Header from './Header';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { contactConfig } from '../config/contactConfig';

const Layout = ({ children, title, description, keywords }) => {
  const defaultTitle = 'Kepenk Servisi İstanbul | 7/24 Acil Tamir & Sıfır Kepenk';
  const defaultDescription =
    'İstanbul 7/24 kepenk servisi ve tamiri. Motor, kumanda, ray arızasında yerinde garantili müdahale. Sıfır kepenk, ücretsiz keşif. ☎ 0501 081 71 61.';
  const defaultKeywords =
    'kepenk servisi istanbul, kepenk tamiri, otomatik kepenk servisi, acil kepenk tamiri, 7/24 kepenk servisi, sıfır kepenk';

  const handlePhoneClick = () => {
    // Google Ads dönüşüm izleme - Telefon araması
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18453542500/phone_call',
      'event_callback': () => { }
    });
  };

  const handleWhatsAppClick = () => {
    // Google Ads dönüşüm izleme - WhatsApp mesajı
    window.gtag('event', 'conversion', {
      'send_to': 'AW-18453542500/7gwOCIPK6ooaEMnAh_wq',
      'event_callback': () => { }
    });
  };

  return (
    <>
      <Helmet>
        <title>{title || defaultTitle}</title>
        <meta name="description" content={description || defaultDescription} />
        <meta name="keywords" content={keywords || defaultKeywords} />
        <meta property="og:title" content={title || defaultTitle} />
        <meta
          property="og:description"
          content={description || defaultDescription}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Güven Kepenk" />
        <meta property="og:locale" content="tr_TR" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />
        <html lang="tr" />
        <style>
          {`
            @keyframes pulse {
              0% {
                transform: scale(1);
                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
              }

              70% {
                transform: scale(1.05);
                box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
              }

              100% {
                transform: scale(1);
                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
              }
            }

            .pulse {
              animation: pulse 2s infinite;
            }
          `}
        </style>
      </Helmet>
      <div className="min-h-screen flex flex-col">
        <TopBanner />
        <Header />
        <main className="flex-grow pt-28">
          {children}
        </main>
        <Footer />

        {/* Sabit Pozisyonlu Butonlar */}
        <div className="fixed left-4 top-3/4 -mt-[45px] z-50 flex flex-col gap-4 md:hidden">
          <a
            href={`tel:${contactConfig.phone}`}
            onClick={handlePhoneClick}
            className="w-16 h-16 flex items-center justify-center rounded-full bg-[#00c1c1] text-white shadow-lg hover:bg-[#00a1a1] transition-colors pulse"
            aria-label="Bizi Arayın"
          >
            <FontAwesomeIcon icon={faPhone} size="2x" />
          </a>
        </div>
        <div className="fixed right-4 top-3/4 -mt-[45px] z-50 flex flex-col gap-4 md:hidden">
          <a
            href={`https://wa.me/${contactConfig.whatsapp}?text=${encodeURIComponent(contactConfig.whatsappMessage)}`}
            onClick={handleWhatsAppClick}
            target="_blank"
            rel="noopener noreferrer"
            className="w-16 h-16 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#20bd5a] transition-colors pulse"
            aria-label="WhatsApp ile İletişime Geçin"
          >
            <FontAwesomeIcon icon={faWhatsapp} size="2x" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Layout; 